// Manda al servidor un paso de la página de después de la baja que solo ve el navegador: abrir la
// lista de newsletters o abrir la encuesta (US-147-2.4.2). Los eventos de la baja salen del servidor
// (`Analitica::PasosDeLaBaja`), porque las páginas de baja no cargan GTM.
//
// Nunca lanza ni espera: medir no puede estorbar a lo que la persona acaba de pulsar.
export function mandaPasoDeLaBaja (url) {
  if (!url) return

  try {
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    fetch(url, { method: 'POST', keepalive: true, credentials: 'same-origin', headers: { 'X-CSRF-Token': token } })
      .catch(() => {})
  } catch (_error) {
    // Sin `fetch` no se mide, y la página sigue igual.
  }
}
